import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_VEHICLES](state, data) {
    console.log('mutation ', data)
    state.allVehicles = data
  },
  [types.SAVE_VEHICLE](state, data) {
    console.log('mutation ', data)
    state.vehicle = data
  },
}
